import React, { useEffect, useRef } from 'react';
import { useAtom } from 'jotai';
import { languageAtom } from '../atoms/languageAtom';

const Menu = () => {
  const titleRef = useRef(null);
  const descRef = useRef(null);
  const [language] = useAtom(languageAtom);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        for (const entry of entries) {
          if (entry.isIntersecting) {
            entry.target.classList.add('show');
          } else {
            entry.target.classList.remove('show');
          }
        }
      },
      {
        threshold: 0.1, // 10% 이상 보일 때 실행
      }
    );

    // title 관찰 추가 (null 체크)
    if (titleRef.current) {
      observer.observe(titleRef.current);
    }

    // desc items 관찰 (null 체크)
    if (descRef.current) {
      const items = descRef.current.children;
      for (const item of Array.from(items)) {
        if (item) {
          observer.observe(item);
        }
      }
    }

    return () => observer.disconnect();
  }, []);

  return (
    <section id="menu" data-section="menu">
      <div className="menu__inner">
        <h2 className="menu__title" ref={titleRef}>
          Menu
        </h2>
      </div>
      <div className="menu__desc" ref={descRef}>
        {/* <div className="menu__desc__item">
                    <b>Lunch Menu</b>
                    <a className={"menu"} rel="noreferrer" href="//cdn.data.mosuseoul.com/Lunch.pdf" target="_blank"
                        title="download Lunch pdf">Download</a>
                </div>

                <div className="menu__desc__item">
                    <b>Dinner Menu</b>
                    <a className={"menu"} rel="noreferrer" href="//cdn.data.mosuseoul.com/Dinner.pdf" target="_blank"
                        title="download Dinner pdf">Download</a>
                </div>*/}

        {language === 'en' ? (
          <>
            {/* <div className="menu__desc__item">
              <a className={'menu text-link'} href="#menu">
                * Coming soon
              </a>
            </div> */}
            <div className="menu__desc__item">
              <b>* Wine List</b>
              <a
                className={'menu'}
                rel="noreferrer"
                href="//cdn.data.mosuseoul.com/Winelist.pdf"
                target="_blank"
                title="download Wine List pdf"
              >
                Download
              </a>
            </div>
            <div className="menu__desc__item">
              <b>Corkage</b>
              <b>One bottle of wine available per table (based on 750ml)</b>
            </div>
          </>
        ) : (
          <>
            {/* <div className="menu__desc__item">
              <a className={'menu text-link'} href="#menu">
                * Dinner Menu 준비중입니다.
              </a>
            </div> */}
            <div className="menu__desc__item">
              <b>* Wine List</b>
              <a
                className={'menu'}
                rel="noreferrer"
                href="//cdn.data.mosuseoul.com/Winelist.pdf"
                target="_blank"
                title="download Wine List pdf"
              >
                Download
              </a>
            </div>
            <div className="menu__desc__item">
              <b>Corkage</b>
              <b className="menu__desc__item__text kr">
                테이블 당 최대 와인 1병 반입 가능(750ml 기준){' '}
              </b>
            </div>
          </>
        )}
      </div>
    </section>
  );
};

export default Menu;
